import { authApi } from "../../../common/redux/services/auth";
import { mainServiceURL } from "../../../common/redux/services/defines";
import { DataResponseDTO } from "../../../common/utils/response.dto";

interface SettingsResponse {
  data: any;
}

interface MenuResponse {
  data: any[];
}

export const settingsApi = authApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchSetting: builder.query<SettingsResponse, void>({
      query: () => mainServiceURL + `/settings/current`,
      providesTags: ["Settings"],
    }),
    fetchMenu: builder.query<MenuResponse, void>({
      query: () => mainServiceURL + `/settings/menu`,
      transformResponse: (response: DataResponseDTO<any>) => {
        const transformedResponse = response.data;
        return transformedResponse;
      },
      providesTags: ["SettingsMenu"],
    }),

    updateSetting: builder.mutation({
      query: ({ id, ...setting }) => ({
        url: mainServiceURL + `/settings/${id}`,
        method: "PUT",
        body: setting,
      }),
      invalidatesTags: ["Settings"],
    }),
  }),
});

export const {
  useFetchSettingQuery,
  useFetchMenuQuery,
  useLazyFetchSettingQuery,
  useUpdateSettingMutation,
} = settingsApi;
